module.exports = __webpack_public_path__ + "img/9e7df5e.jpg";